module.exports = __webpack_public_path__ + "static/assets/8fbace395b5c622ed74e2d396f2753fd.svg";